import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { IIacmacImportQueryResult, MergeIacmacForm, MergeIacmacResource } from 'src/app/models/iiacmac.interface';
import { IPerson } from 'src/app/models/iperson.interface';
import { HTTP_CONTENT_HEADERS } from 'src/app/shared/data/const.data';
import { environment } from 'src/environments/environment';
import { MessageToastService } from '../common/message-toast.service';

@Injectable({
  providedIn: 'root'
})
export class IacmacService {

  private url = 'iacmac';
  private api = environment.apiUrl;

  constructor(private http: HttpClient, private msg: MessageToastService) { }

  getTable(filter: string): Observable<IIacmacImportQueryResult> {
    return this.http.get<IIacmacImportQueryResult>(`${this.api}${this.url}/table/?${filter}`).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  getMatches(id: string) : Observable<MergeIacmacResource> {
    return this.http.get<MergeIacmacResource>(`${this.api}${this.url}/matches/${id}`).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  mergeSingle(form: MergeIacmacForm) : Observable<IPerson> {
    return this.http.post<IPerson>(`${this.api}${this.url}/merge`, form).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  delete(ids: string[]) {
    return this.http.post(`${this.api}${this.url}/delete`, ids).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  import(formData: FormData) {
    const urlUpload = `${this.api}${this.url}/import`;
    return this.http.post<any>(urlUpload, formData, { reportProgress: true, observe: 'events' });
  }

  export() {
    const url = `${this.api}${this.url}/export`;

    let hdrs = new HttpHeaders();
    hdrs = hdrs.set('Accept', HTTP_CONTENT_HEADERS.Excel)

    return this.http.get(url, {
      observe: 'response',
      headers: hdrs,
      responseType: 'blob'
    }).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }
}
